/**
 * Styles for MarkdownRenderer component.
 */

.code-block {
  max-width: 100%;
  overflow-x: auto;
}

.code-block code {
  /* Let Mantine Code handle the styling */
  padding: 0;
  /* Let Mantine Code handle the styling */
  background: transparent;
}
